module.exports = __webpack_public_path__ + "img/fwdw_01.1f5a297d.jpg";